import { c as _c } from "react-compiler-runtime";
import Script from "next/script";
export type JsonLdProps<TData extends object> = {
  /**
   * Unique DOM id for the script tag (helps avoid duplicates and aids debugging).
   */
  id: string;
  data: TData;
};

/**
 * Server-friendly JSON-LD helper using `next/script`.
 */
export function JsonLd(t0) {
  const $ = _c(7);
  const {
    id,
    data
  } = t0;
  let t1;
  if ($[0] !== data) {
    t1 = JSON.stringify(data);
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      __html: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== id || $[5] !== t2) {
    t3 = <Script dangerouslySetInnerHTML={t2} id={id} type="application/ld+json" />;
    $[4] = id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}